import { render, staticRenderFns } from "./TradeRequestChatsWithAdminList.vue?vue&type=template&id=3b592f32&scoped=true"
import script from "./TradeRequestChatsWithAdminList.vue?vue&type=script&lang=js"
export * from "./TradeRequestChatsWithAdminList.vue?vue&type=script&lang=js"
import style0 from "./TradeRequestChatsWithAdminList.vue?vue&type=style&index=0&id=3b592f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b592f32",
  null
  
)

export default component.exports